<mat-form-field appearance="outline" class="udp-field">
    <mat-label>{{ effectiveLabel() }}</mat-label>
    <input matInput
           [formControl]="inputControl"
           [placeholder]="placeholder || ('Search ' + type + ' by key or label…')"
           [matAutocomplete]="udpAuto"
           [required]="required" />

    <mat-autocomplete #udpAuto="matAutocomplete"
                      [displayWith]="displayFn"
                      (optionSelected)="onOptionSelected($event)">
        <mat-option *ngIf="loading" disabled>
            <mat-icon class="udp-spin">progress_activity</mat-icon>
            Loading {{ type }}…
        </mat-option>
        <mat-option *ngIf="!loading && loadError" disabled>
            <mat-icon class="udp-err">error_outline</mat-icon>
            {{ loadError }}
        </mat-option>
        <mat-option *ngIf="!loading && !loadError && filtered.length === 0" disabled>
            <mat-icon>search_off</mat-icon>
            No {{ type }} rows match.
        </mat-option>
        <mat-option *ngFor="let r of filtered" [value]="r.key">
            <span class="udp-opt-key">{{ r.key }}</span>
            <span class="udp-opt-sep" *ngIf="r.label">—</span>
            <span class="udp-opt-label" *ngIf="r.label">{{ r.label }}</span>
        </mat-option>
    </mat-autocomplete>

    <button mat-icon-button matSuffix
            *ngIf="inputControl.value && !disabled"
            (click)="onClear(); $event.stopPropagation()"
            aria-label="Clear selection">
        <mat-icon>close</mat-icon>
    </button>
    <mat-icon matSuffix *ngIf="!inputControl.value">unfold_more</mat-icon>

    <mat-hint *ngIf="!loadError">{{ rows.length }} {{ type }} row{{ rows.length === 1 ? '' : 's' }} available</mat-hint>
    <mat-error *ngIf="inputControl.hasError('required')">{{ effectiveLabel() }} is required</mat-error>
</mat-form-field>
